var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSpeakerLight = function SvgIconSpeakerLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_speaker_light_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_speaker_light_svg__b)",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.08 36.41c-.46 0-.93-.15-1.32-.43l-8.4-6.11H12.1a4.55 4.55 0 0 1-4.54-4.54v-2.67c0-2.5 2.04-4.54 4.54-4.54h2.26l8.4-6.11c.69-.5 1.58-.57 2.34-.18.76.38 1.23 1.15 1.23 2v20.33c0 .85-.47 1.62-1.23 2-.32.17-.67.25-1.02.25ZM12.1 20.32c-1.29 0-2.34 1.05-2.34 2.34v2.67c0 1.29 1.05 2.34 2.34 2.34h2.62c.23 0 .46.07.65.21l8.69 6.32.07-20.37-8.76 6.28c-.19.14-.41.21-.65.21H12.1ZM34.89 35.7l-1.55-1.55c2.72-2.72 4.22-6.35 4.22-10.2 0-3.85-1.49-7.43-4.18-10.15l1.56-1.55c3.11 3.13 4.82 7.29 4.82 11.7 0 4.41-1.73 8.62-4.87 11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.19 31-1.55-1.55a7.723 7.723 0 0 0 2.28-5.5c0-2.08-.79-3.98-2.24-5.45l1.57-1.54a9.908 9.908 0 0 1 2.87 6.99A9.97 9.97 0 0 1 31.2 31h-.01Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_speaker_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_speaker_light_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconSpeakerLight;